import React from 'react';
import { Card, renderSignedExpertsRow } from 'components';
import { IExamExpert } from 'components/models';

const ExpertsSignProgress = ({ experts }: IProps) => (
    <Card
      title="Экспертная комиссия"
      category="Ожидание подтверждения участия экспертов в экзамене"
      withoutBorder
    >
        <div style={{ maxWidth: 'max-content' }}>
            {renderSignedExpertsRow(experts, 'экспертной комиссии', true)}
        </div>
    </Card>
);

export default ExpertsSignProgress;

interface IProps {
    experts: IExamExpert[];
}
